import React from "react";

const STATUS_STYLE = {
  TRIAL: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  ACTIVE: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  SUSPENDED: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  EXPIRED: "bg-rose-500/15 text-rose-400 border-rose-500/30",
  NONE: "bg-white/10 text-white/60 border-white/10",
};

export function SubscriptionStatusBadge({ status, size = "md" }) {
  const s = (status || "NONE").toUpperCase();
  const style = STATUS_STYLE[s] || STATUS_STYLE.NONE;
  const px = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span data-testid={`sub-status-${s.toLowerCase()}`}
      className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${px} ${style}`}>
      {s}
    </span>
  );
}

const TYPE_STYLE = {
  TRIAL: "bg-sky-500/15 text-sky-300",
  MONTHLY: "bg-slate-500/15 text-slate-300",
  SIX_MONTHS: "bg-violet-500/15 text-violet-300",
  YEARLY: "bg-emerald-500/15 text-emerald-300",
  LIFETIME: "bg-amber-500/15 text-amber-300",
};

export function SubscriptionTypeBadge({ type, size = "md" }) {
  const t = (type || "").toUpperCase();
  const style = TYPE_STYLE[t] || "bg-white/10 text-white/60";
  const px = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span className={`inline-flex items-center rounded-full font-black uppercase tracking-wider ${px} ${style}`}>
      {t.replace("_", " ") || "—"}
    </span>
  );
}
